import { useNavigate } from 'react-router-dom'
import { MoveOption } from '../Storage.types'

export const STORAGE_SCAN_DESTINATION_URL = '/to-storage/:containerName/send'

export const useGoToStorageScanDestinationDetail = () => {
  const navigate = useNavigate()

  return {
    go: (containerName: string, moveOption: MoveOption) => {
      const url = STORAGE_SCAN_DESTINATION_URL.replace(
        ':containerName',
        containerName
      )
      navigate(`${url}?moveOption=${moveOption}`)
    }
  }
}
